module.exports = __webpack_public_path__ + "static/media/sample_mll_bulk_trainloading.c63c8706.csv";